import React from 'react';
import './Philosophy.css';

const Philosophy = () => {
    return (
        <section className="philosophy-section">
            <div className="container">
                <h2 className="text-center">Notre Philosophie</h2>

                <div className="philosophy-content">
                    <div className="philosophy-text-content">
                        <div className="philosophy-feature">
                            <h4>Une Pâtisserie Raisonnée</h4>
                            <p>Une pâtisserie moins sucrée, mettant en avant le goût originel des produits. Nous travaillons exclusivement avec des fruits de saison et des producteurs locaux respectueux de l'environnement.</p>
                        </div>

                        <div className="philosophy-feature">
                            <h4>Mariages Surprenants</h4>
                            <p>Dans chaque dessert viennent se mêler des saveurs inattendues : herbes, épices, arômes, légumes. Cédric crée des mariages imprévisibles pour un véritable voyage gustatif qui fait appel aux sens et aux souvenirs.</p>
                        </div>

                        <div className="philosophy-feature">
                            <h4>Justesse du Goût</h4>
                            <p>Toujours à la recherche de l'équilibre, nous imaginons au fil des saisons des créations où la promesse est celle de la justesse absolue du goût.</p>
                        </div>
                    </div>

                    <div className="philosophy-image-content">
                        <img src="/images/tarn_pastry_4.jpg" alt="Création signature" className="philosophy-image" />
                        <div className="philosophy-caption">Création de saison</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Philosophy;
